import { render, staticRenderFns } from "./DepartmentPriceSetting.vue?vue&type=template&id=5f5df64d"
import script from "./DepartmentPriceSetting.vue?vue&type=script&lang=js"
export * from "./DepartmentPriceSetting.vue?vue&type=script&lang=js"
import style0 from "./DepartmentPriceSetting.vue?vue&type=style&index=0&id=5f5df64d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports